import { service } from '@maia/customer';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Insurances = Awaited<ReturnType<(typeof service)['getInsurances']>>;

export function getInsurancesOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Insurances>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'insurances', guid, [search]],
    queryFn: async () => await service.getInsurances(guid, search),
    initialData,
  });
}
